interface SeoData {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogType?: string;
  publishedDate?: string;
  modifiedDate?: string;
}

export default function SeoHead({ data }: { data: SeoData }) {
  const {
    title,
    description,
    canonicalUrl = 'https://jiuyou.com',
    ogType = 'website',
    publishedDate,
    modifiedDate,
  } = data;

  useEffect(() => {
    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    const ogTypeEl = document.querySelector('meta[property="og:type"]');
    if (ogTypeEl) ogTypeEl.setAttribute('content', ogType);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', canonicalUrl);

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', title);

    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);
  }, [title, description, canonicalUrl, ogType]);

  useEffect(() => {
    if (modifiedDate) {
      const existing = document.querySelector('meta[name="last-modified"]');
      if (existing) {
        existing.setAttribute('content', modifiedDate);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'last-modified';
        meta.content = modifiedDate;
        document.head.appendChild(meta);
      }
    }
  }, [modifiedDate]);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': ogType === 'article' ? 'Article' : 'WebPage',
    name: title,
    description,
    url: canonicalUrl,
    ...(publishedDate && { datePublished: publishedDate }),
    ...(modifiedDate && { dateModified: modifiedDate }),
    isPartOf: {
      '@type': 'WebSite',
      name: 'jiuyou官网',
      url: 'https://jiuyou.com',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}